import http from "./httpService";
import { stuffingChecklistApi } from "./config.json";
import auth from "./authService";

//qc start
export async function getQCStuffingById(id_qc_stuffing) {
  const obj = { id_qc_stuffing };
  const { data } = await http.post(stuffingChecklistApi + "selectoneQCStuffing.php", obj);
  return data;
}
export async function getQCStuffingReport(detail) {
  const obj = { detail };
  const { data } = await http.post(stuffingChecklistApi + "selectQcStuffingReport.php", obj);
  return data;
}
export async function deleteQCStuffing(id_qc_stuffing) {
  const obj = { id_qc_stuffing };
  const { data } = await http.post(stuffingChecklistApi + "deleteQCStuffing.php", obj);
  return data;
}
export async function getDataQCStuffing(search, limit, offset, order, type) {
  const obj = { search, limit, offset, order, type };
  const { data } = await http.post(stuffingChecklistApi + "selectDataQCStuffing.php", obj);
  return data;
}
//qc end

//checklist stuffing start
export async function getAllStuffing(id_stuffing_type) {
  const obj = { id_stuffing_type };
  const { data } = await http.post(stuffingChecklistApi + "selectAllStuffing.php",obj);
  return data;
}

export async function getDataStuffing(search, limit, offset, order, type) {
  const obj = { search, order, type, limit, offset };
  const { data } = await http.post(stuffingChecklistApi + "selectDataStuffing.php", obj);
  return data;
}

export async function getStuffingById(id_stuffing_checklist) {
  const obj = { id_stuffing_checklist };
  const { data } = await http.post(stuffingChecklistApi + "selectoneStuffing.php", obj);
  return data;
}
export async function deleteStuffing(id_stuffing_checklist) {
  const obj = { id_stuffing_checklist };
  const { data } = await http.post(stuffingChecklistApi + "deleteStuffing.php", obj);
  return data;
}
export async function getStuffingForModal(val) {
  const obj = { val };
  const { data } = await http.post(
    stuffingChecklistApi + "selectModalStuffing.php",
    obj
  );
  return data;
}
export async function insertStuffing(detail) {
  const username = auth.getCurrentUser();
  const obj = { detail, username };
  const { data } = await http.post(stuffingChecklistApi + "insertStuffing.php", obj);
  return data;
}
export async function updateStuffing(detail) {
  const obj = { detail };
  const { data } = await http.post(stuffingChecklistApi + "updateStuffing.php", obj);
  return data;
}
//checklist stuffing end


// WEBPACK FOOTER //
// ./src/services/stuffingServices.js